import API from '../api'
import postUrl from './paths'

export const sendApprovalMessage = ({ creditApprovalId, message }) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.sendApprovalMessage, {}, { creditApprovalId, message })
			.then((response) => {
				resolve(response)
			})
			.catch((err) => reject(err))
	})

export const uploadApprovalDocument = (file, creditApprovalId) =>
	new Promise((resolve, reject) => {
		const formData = new FormData()
		file && formData.append('file', file)
		API.post(postUrl.uploadApprovalDocument, formData, { creditApprovalId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})
